import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {postCalendarView, putCalendarView} from '../../../services/calendarViews'

export async function createCalendarView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await postCalendarView(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}

export async function updateCalendarView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await putCalendarView(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Update Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
